/**
 * @generated SignedSource<<3ef0fbf62e8e99923794129db4d61ac9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetListType = "COMMODITY" | "CRYPTOCOIN" | "EQUITY_SECURITY" | "INDEX" | "SECURITY";
export type AssetsGroupKey = "CRYPTO" | "ETC" | "ETF" | "INDEX" | "METAL" | "STOCK";
export type AssetsListGroup = "COIN" | "EQUITY_COMPLEX_ETC" | "EQUITY_COMPLEX_ETF" | "EQUITY_ETC" | "EQUITY_ETF" | "EQUITY_STOCK" | "ETC" | "ETF" | "INDEX" | "METAL" | "SECURITY_TOKEN" | "STOCK" | "TOKEN";
export type AssetsListSortBy = "MARKETCAP" | "NAME" | "PRICE" | "PRICE_CHANGE_1MONTH" | "PRICE_CHANGE_1WEEK" | "PRICE_CHANGE_1YEAR" | "PRICE_CHANGE_24HOURS";
export type SortOrder = "ASC" | "DESC";
export type AssetsListInput = {
  after?: string | null | undefined;
  allowBuy?: boolean | null | undefined;
  before?: string | null | undefined;
  first?: number | null | undefined;
  group?: AssetsListGroup | null | undefined;
  groups?: ReadonlyArray<AssetsListGroup> | null | undefined;
  last?: number | null | undefined;
  searchTerm?: string | null | undefined;
  sortBy?: AssetsListSortBy | null | undefined;
  sortOrder?: SortOrder | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
  type?: AssetListType | null | undefined;
  types?: ReadonlyArray<AssetListType> | null | undefined;
};
export type GetPaginatedAssetsForTransfersQuery$variables = {
  input?: AssetsListInput | null | undefined;
};
export type GetPaginatedAssetsForTransfersQuery$data = {
  readonly assetGroups: ReadonlyArray<{
    readonly __typename: "AssetGroup";
    readonly key: AssetsGroupKey;
    readonly value: ReadonlyArray<AssetsListGroup>;
  }>;
  readonly assets: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly id: string;
        readonly logoUrl: string | null | undefined;
        readonly marketCap: number | null | undefined;
        readonly name: string | null | undefined;
        readonly networkInformation?: {
          readonly defaultNetworkId: string;
          readonly networks: ReadonlyArray<{
            readonly coinNetworkId: string;
            readonly destinationTag: string | null | undefined;
            readonly id: string;
            readonly isDepositAllowed: boolean;
            readonly isOperational: boolean;
            readonly isWithdrawalAllowed: boolean;
            readonly logoUrl: string | null | undefined;
            readonly maximumTransactionPrecision: number | null | undefined;
            readonly minDepositThreshold: PrecisionFloat | null | undefined;
            readonly minWithdrawalFee: PrecisionFloat | null | undefined;
            readonly minWithdrawalThreshold: PrecisionFloat | null | undefined;
            readonly name: string | null | undefined;
            readonly smallDepositFee: PrecisionFloat | null | undefined;
            readonly smallDepositThreshold: PrecisionFloat | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly portfolio: {
          readonly assetBalance: PrecisionFloat | null | undefined;
          readonly fiatBalance: PrecisionFloat | null | undefined;
        } | null | undefined;
        readonly price: PrecisionFloat | null | undefined;
        readonly symbol: string | null | undefined;
      };
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    } | null | undefined;
    readonly totalCount: number | null | undefined;
  } | null | undefined;
};
export type GetPaginatedAssetsForTransfersQuery = {
  response: GetPaginatedAssetsForTransfersQuery$data;
  variables: GetPaginatedAssetsForTransfersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AssetGroup",
    "kind": "LinkedField",
    "name": "assetGroups",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      (v1/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AssetsConnection",
    "kind": "LinkedField",
    "name": "assets",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNextPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endCursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startCursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasPreviousPage",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AssetsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "symbol",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "marketCap",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "price",
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AssetPortfoliosConnection",
                "kind": "LinkedField",
                "name": "portfolio",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assetBalance",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fiatBalance",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssetNetworkInformation",
                    "kind": "LinkedField",
                    "name": "networkInformation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "defaultNetworkId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Network",
                        "kind": "LinkedField",
                        "name": "networks",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "coinNetworkId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "destinationTag",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isOperational",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDepositAllowed",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minDepositThreshold",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "smallDepositFee",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "smallDepositThreshold",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "maximumTransactionPrecision",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isWithdrawalAllowed",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minWithdrawalFee",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minWithdrawalThreshold",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "CryptoAsset",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetPaginatedAssetsForTransfersQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetPaginatedAssetsForTransfersQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "fc47050aa8035e8559d0a15251d8d47a",
    "id": null,
    "metadata": {},
    "name": "GetPaginatedAssetsForTransfersQuery",
    "operationKind": "query",
    "text": "query GetPaginatedAssetsForTransfersQuery(\n  $input: AssetsListInput\n) {\n  assetGroups {\n    key\n    value\n    __typename\n  }\n  assets(input: $input) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      startCursor\n      hasPreviousPage\n    }\n    totalCount\n    edges {\n      node {\n        id\n        symbol\n        logoUrl\n        name\n        marketCap\n        price\n        __typename\n        portfolio {\n          assetBalance\n          fiatBalance\n        }\n        ... on CryptoAsset {\n          networkInformation {\n            defaultNetworkId\n            networks {\n              id\n              name\n              coinNetworkId\n              destinationTag\n              logoUrl\n              isOperational\n              isDepositAllowed\n              minDepositThreshold\n              smallDepositFee\n              smallDepositThreshold\n              maximumTransactionPrecision\n              isWithdrawalAllowed\n              minWithdrawalFee\n              minWithdrawalThreshold\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1f7c645d37b71c85a67935f148af200";

export default node;
